import { postRequest } from '../utils';

async function startExecuteMyMutation(set, id: number) {
  const result = await postRequest(`/api/views/${id}`, set);
  if (result?.errors) {
    console.error(result.errors);
    return { errors: result.errors };
  }
  return result;
}

export const updateView = (set, id: number) => startExecuteMyMutation(set, id);
